// auth-token.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { UserApiService, AuthTokenHandler } from '@vtnz/api';
import { LoginService, UserService } from '@vtnz/ui';

// Create the shared handler instance for customer portal
const authHandler = new AuthTokenHandler();

/**
 * HTTP Interceptor function:
 * - Adds Bearer token to requests (token stored in memory only)
 * - On 401, refreshes the token once and retries the original request
 */
export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const userApiService = inject(UserApiService);
  const userService = inject(UserService);
  const loginService = inject(LoginService);

  return authHandler.handle(
    req,
    next,
    userApiService,
    () => userService.apiToken(),
    (token) => userService.setApiToken(token),
    () => userService.userId(),
    () => loginService.logout()
  );
};
